module.exports = __webpack_public_path__ + "media/images/haircut/alexandre-01d9d10bd5f19d463566f2023339fcc1.jpg";